import { render, staticRenderFns } from "./r-world-region-territory-dialog.vue?vue&type=template&id=116a55e6"
import script from "./r-world-region-territory-dialog.vue?vue&type=script&lang=js"
export * from "./r-world-region-territory-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116a55e6')) {
      api.createRecord('116a55e6', component.options)
    } else {
      api.reload('116a55e6', component.options)
    }
    module.hot.accept("./r-world-region-territory-dialog.vue?vue&type=template&id=116a55e6", function () {
      api.rerender('116a55e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-region-territory/r-world-region-territory-dialog.vue"
export default component.exports